export default __webpack_public_path__ + "static/media/hypurrco.d4ae74f3.png";